var map = {
	"./allinc.png": 98,
	"./allinclusive.png": 4738,
	"./alpereiser.png": 2236,
	"./amisol.png": 926,
	"./apollo.png": 9848,
	"./escapeaway.png": 7644,
	"./kroatiaspesialisten.png": 8157,
	"./lionalpin.png": 3614,
	"./loveholidays.png": 1164,
	"./mixxtravel.png": 9248,
	"./nazar.png": 318,
	"./norwegianholidays.png": 623,
	"./solfaktor.png": 5760,
	"./solia.png": 6256,
	"./soliadynamic.png": 8018,
	"./test.png": 7765,
	"./ticket.png": 8376,
	"./tripx.png": 3428,
	"./tui.png": 4684,
	"./tyrkiareiser.png": 5341,
	"./ving.png": 2607,
	"./vingdynamic.png": 2103,
	"./vitalreiser.png": 5041,
	"src/static/logo/supplier/66x22/allinc.png": 98,
	"src/static/logo/supplier/66x22/allinclusive.png": 4738,
	"src/static/logo/supplier/66x22/alpereiser.png": 2236,
	"src/static/logo/supplier/66x22/amisol.png": 926,
	"src/static/logo/supplier/66x22/apollo.png": 9848,
	"src/static/logo/supplier/66x22/escapeaway.png": 7644,
	"src/static/logo/supplier/66x22/kroatiaspesialisten.png": 8157,
	"src/static/logo/supplier/66x22/lionalpin.png": 3614,
	"src/static/logo/supplier/66x22/loveholidays.png": 1164,
	"src/static/logo/supplier/66x22/mixxtravel.png": 9248,
	"src/static/logo/supplier/66x22/nazar.png": 318,
	"src/static/logo/supplier/66x22/norwegianholidays.png": 623,
	"src/static/logo/supplier/66x22/solfaktor.png": 5760,
	"src/static/logo/supplier/66x22/solia.png": 6256,
	"src/static/logo/supplier/66x22/soliadynamic.png": 8018,
	"src/static/logo/supplier/66x22/test.png": 7765,
	"src/static/logo/supplier/66x22/ticket.png": 8376,
	"src/static/logo/supplier/66x22/tripx.png": 3428,
	"src/static/logo/supplier/66x22/tui.png": 4684,
	"src/static/logo/supplier/66x22/tyrkiareiser.png": 5341,
	"src/static/logo/supplier/66x22/ving.png": 2607,
	"src/static/logo/supplier/66x22/vingdynamic.png": 2103,
	"src/static/logo/supplier/66x22/vitalreiser.png": 5041
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2281;